import { LayoutHOC } from 'base/ui/layout/layout';
import { createWODetail } from './workOrderDetails';

export const createWODetailPage = (layoutHOC: LayoutHOC) => {
  return layoutHOC(createWODetail());
};
